// extracted by mini-css-extract-plugin
export default {"banner":"_47LN0PUHxUoR6c2EvNdohF","text":"_2GT3rh1QR7S3QuT4PI5FZO","cta":"Cc5doqUgVxgjQzfx3IMbh"};